
import { IconTag, IconTrain } from "@tabler/icons-react";
import type { BRAKE_VC_LOGS_MONITORING_HEALTH, BRAKE_VC_LOGS_MONITORING_REPORT, CAB_RFID_READER_REPORT, CARD_DIAGNOSTICS_HEALTH, CARD_DIAGNOSTICS_REPORT, CARD_STATUS_REPORT, CHANGEOVER_OF_CARDS_REPORT, CHECKSUM_CHANGE_REPORT, CRASH_LOGS_REPORT, DMI_HEALTH_MONITORING_REPORT, EIGW_FAILURE_REPORT, EVENT_TABLE, EventPoint, FIND_TRIPS_REPORT, FIU_REPORT, HEALTH_TIMELINE_TABLE, LikelyFaultyTag, LikelyReaderFault, LOCO_HEALTH, LocoStationMissHeatmap, MONITORING_BOOT_LOGS_REPORT, RADIO_PARAMETERS_MONITORING_REPORT, READER_EFFICIENCY_REPORT, RF_ISSUES_LOCO_REPORT, RF_ISSUES_STATION_REPORT, RIU_REPORT, S2S_LINK_FAILURE_REPORT, SIGNAL_ASPECT_BLANKING_REPORT, SIGNAL_BLANKING_REPORT, SPEEDOMETER_HEALTH_MONITORING_REPORT, STATION_HEALTH, STATION_METADATA, SYSTEM_FAILURE_REPORT, TAG_MISSING_NEW_REPORT, TAG_MISSING_REPORT, UNWANTED_BRAKING_REPORT } from "../interfaces/dashboard";
import { TABLE_COLUMNS_CONFIG } from "./table.cnst";

export const EVENTS_TABLE_DATA: EVENT_TABLE[] = [
  {
    eventId: '28',
    locoId: 6399,
    zoneName: 'Central Railway Zone',
    stationId: 33445,
    absoluteLocation: 482347,
    eventTimestamp: '28/11/23, 11:23:44',
    eventCategory: 'Undesirable Braking'
  },
  {
    eventId: '28',
    locoId: 6398,
    zoneName: 'Central Railway Zone',
    stationId: 33445,
    absoluteLocation: 482348,
    eventTimestamp: '28/11/23, 11:23:44',
    eventCategory: 'Mode Degradation'
  },
  {
    eventId: '28',
    locoId: 6397,
    zoneName: 'Central Railway Zone',
    stationId: 33444,
    absoluteLocation: 482349,
    eventTimestamp: '28/11/23, 11:23:44',
    eventCategory: 'Over Speeding'
  }
]

export const EVIDENCE_TIMELINE_TABLE_DATA = [
  {
    time: '11:23:44',
    description: 'Emergency Braking triggered due to obstacle on track.',
    source: 'Loco ',
    packet: 'LocoReg'
  },
  {
    time: '10:23:44',
    description: 'MA Updation Failed.',
    source: 'Station',
    packet: 'S25'
  },
]

export const STATIONS = [
  { label: "Visakhapatnam", status: "kavach" },
  { label: "Anakapalle", status: "kavach" },
  { label: "Narasapur", status: "kavach" },
  { label: "Tuni", status: "non-kavach" },
  { label: "Annavaram", status: "non-kavach" },
  { label: "Samalkot", status: "non-kavach" },
  { label: "Rajahmundry", status: "kavach" },
  { label: "Tadepalligudem", status: "kavach" },
  { label: "Eluru", status: "kavach" },
  { label: "Vijayawada", status: "kavach" },
  { label: "Guntur", status: "kavach" },
  { label: "Nalgonda", status: "kavach" },
  { label: "Secunderabad", status: "kavach" },
  { label: "Hyderabad", status: "kavach" }
];

export const RAILWAY_ZONES: EventPoint[] = [
  {
    zoneName: "Central Railway Zone",
    coordinates: [22.5744, 88.3629],
    eventCount: 0,
    zoneCode: 'CR',
    zoneId: '',
    project: [
      {
        label: 'PUNE',
        value: 'PUNE'
      },
      {
        label: 'BHUSAVAL',
        value: 'BHUSAVAL'
      },
      {
        label: 'NAGPUR',
        value: 'NAGPUR'
      },
      {
        label: 'SOLAPUR',
        value: 'SOLAPUR'
      },
      {
        label: 'MUMBAI',
        value: 'MUMBAI'
      }
    ]
  },
  {
    zoneName: "Eastern Railway Zone",
    coordinates: [22.5744, 88.3629],
    eventCount: 0,
    zoneCode: 'ER',
    zoneId: '',
    project: [
      {
        label: 'BENGAL TIGER',
        value: 'BENGAL TIGER'
      }
    ]
  },
  {
    zoneName: "Eastern Central Railway Zone",
    coordinates: [22.5744, 88.3629],
    eventCount: 0,
    zoneCode: 'ECR',
    zoneId: '',
    project: [
      {
        label: 'ECR',
        value: 'ECR'
      }
    ]
  },
  {
    zoneName: "Western Railway Zone",
    coordinates: [18.9582, 72.8321],
    eventCount: 0,
    zoneCode: 'WR',
    zoneId: '',
    project: [
      {
        label: 'RATLAM',
        value: 'RATLAM'
      },
      {
        label: 'NARMADA',
        value: 'NARMADA'
      },
      {
        label: 'AHEMDABAD',
        value: 'AHEMDABAD'
      },
      {
        label: 'RAJKOT',
        value: 'RAJKOT'
      }
    ]
  },
  {
    zoneName: "West Central Railway Zone",
    coordinates: [23.1686, 79.9339],
    eventCount: 0,
    zoneCode: 'WCR',
    zoneId: '',
    project: [
      {
        label: 'KOTA-RUTHIYAI',
        value: 'KOTA-RUTHIYAI'
      },
      {
        label: 'RANTHAMBHOR',
        value: 'RANTHAMBHOR'
      }
    ]
  },
  {
    zoneName: "North Central Railway Zone",
    coordinates: [25.4683, 81.8546],
    eventCount: 0,
    zoneCode: 'NCR',
    zoneId: '',
    project: [
      {
        label: 'TAJ',
        value: 'TAJ'
      }
    ]
  }
];

export const LOCO_HEALTH_TABLE_DATA: LOCO_HEALTH[] = [
  {
    locoId: 6399,
    route: "Kakinada - Hyderabad",
    rf_strength: "20%",
    loco_uptime: "10%",
    pcb_failures: 2,
    pulse_counter_issues: 1,
    status: "Critical",
    action: ""
  },
  {
    locoId: 6400,
    route: "Vijayawada - Secunderabad",
    rf_strength: "50%",
    loco_uptime: "50%",
    pcb_failures: 0,
    pulse_counter_issues: 0,
    status: "Healthy",
    action: ""
  },
  {
    locoId: 6401,
    route: "Guntur - Hyderabad",
    rf_strength: "35%",
    pcb_failures: 1,
    loco_uptime: "85%",
    pulse_counter_issues: 2,
    status: "Warning",
    action: ""
  }
]

export const STATION_HEALTH_TABLE_DATA: STATION_HEALTH[] = [
  {
    stationId: 33445,
    section: "Kakinada",
    rf_strength: "25%",
    station_availability: "10%",
    missing_tags: 5,
    station_hardware_issues: 2,
    status: "Critical",
    action: ""
  },
  {
    stationId: 33446,
    section: "Vijayawada",
    rf_strength: "55%",
    station_availability: "85%",
    missing_tags: 0,
    station_hardware_issues: 0,
    status: "Healthy",
    action: ""
  },
  {
    stationId: 33447,
    section: "Guntur",
    rf_strength: "40%",
    station_availability: "70%",
    missing_tags: 3,
    station_hardware_issues: 1,
    status: "Warning",
    action: ""
  }
]

export const RF_STRENGTH_TIME_DATA = {
  labels: [
    "00:00",
    "00:30",
    "01:00",
    "01:30",
    "02:00",
    "02:30",
    "03:00",
    "03:30",
    "04:00",
    "04:30",
    "05:00",
    "05:30"
  ],
  datasets: [
    {
      label: "RF Strength",
      data: [-82, -28, 6, -92, -88, -80, -14, -96, -78, -32, -40, 8],
      fill: false,
      borderColor: "#6366f1", // Indigo / blue tone
      backgroundColor: "#6366f1",
      tension: 0.4, // smooth curve
      pointRadius: 4,
      pointHoverRadius: 6,
      pointBackgroundColor: "#ffffff",
      pointBorderColor: "#6366f1",
      pointBorderWidth: 2
    }
  ]
};

export const SPEED_TIME_CHART_DATA = {
  labels: ["5", "10", "15", "20", "25", "30", "35", "45", "55"],
  datasets: [
    {
      label: "Speed",
      data: [165, 165, 90, 85, 30, 10, 8, 8, 8],
      borderColor: "#ff6b6b",
      backgroundColor: "#ff6b6b",
      tension: 0.45,
      fill: false,
      pointRadius: 4,
      pointHoverRadius: 6,
      pointBackgroundColor: "#ffffff",
      pointBorderColor: "#ff6b6b",
      pointBorderWidth: 2
    }
  ]
};

export const TAG_MISSING_REPORT_DATA: TAG_MISSING_REPORT[] = [
  {
    locoId: 6399,
    eventId: '28',
    stationId: 482,
    tripId: 33445,
    cardId: 2,
    lastReadTagId: "10234",
    missedTagId: "10235",
    tagMissCategory: "Main Tag",
    cabActive: "2",
    readerActive: "2",
    syncStatus: "In Sync",
    absoluteLocation: 482736,
    timestamp: "28/01/2026, 16:50:00",
    reason: "Physical Tag Miss",
    tripStart: "28/01/2026, 10:00:00",
    tripEnd: "28/01/2026, 16:50:00",
    progLoc: 1,
    readLoc: 2,
    difference: 1,
    tagWindow: 0
  },
  {
    locoId: 4789,
    eventId: '28',
    stationId: 831,
    tripId: 24680,
    cardId: 2,
    lastReadTagId: "10234",
    missedTagId: "10235",
    tagMissCategory: "Main Tag",
    cabActive: "2",
    readerActive: "2",
    syncStatus: "Out Of Sync",
    absoluteLocation: 374102,
    timestamp: "25/09/2023, 03:05:00",
    reason: "Early Tag Read",
    tripStart: "25/09/2023, 00:00:00",
    tripEnd: "25/09/2023, 03:05:00",
    progLoc: 1,
    readLoc: 2,
    difference: 1,
    tagWindow: 0
  }
]

export const UNWANTED_BRAKING_REPORT_DATA: UNWANTED_BRAKING_REPORT[] = [
  {
    locoId: 6398,
    eventId: '28',
    currentSpeed: 48,
    permittedSpeed: 60,
    targetedSpeed: 55,
    previousMA: "482",
    differenceInMA: "34",
    stationId: 33445,
    tripId: 334,
    cardId: 2,
    syncStatus: "In Sync",
    absoluteLocation: 482736,
    timestamp: "28/01/2026, 16:50:00",
    tripStart: "28/01/2026, 10:00:00",
    tripEnd: "28/01/2026, 16:50:00",
    eventType: 'EB',
    currentMA: 'Invalid',
    brakeDuration: 12.34
  },
  {
    locoId: 4789,
    eventId: '28',
    previousMA: "831",
    currentSpeed: 67,
    permittedSpeed: 80,
    targetedSpeed: 75,
    tripId: 246,
    cardId: 2,
    differenceInMA: "3",
    stationId: 33446,
    syncStatus: "Out Of Sync",
    absoluteLocation: 374102,
    timestamp: "25/09/2023, 03:05:00",
    tripStart: "25/09/2023, 00:00:00",
    tripEnd: "25/09/2023, 03:05:00",
    eventType: 'FSB',
    currentMA: 'Invalid',
    brakeDuration: 1.34
  }
]

export const EVENT_CATEGORIES = [
  {
    label: "Undesirable Braking",
    key: "undesirableBraking",
    backgroundColor: "#F18226"
  },
  {
    label: "Mode Degradation",
    key: "modeDegradation",
    backgroundColor: "#3B8AD9"
  },
  {
    label: "Tag Missing",
    key: "tagMissing",
    backgroundColor: "#7BC0F7"
  },
  {
    label: "Sudden Speed Jump",
    key: "suddenSpeedJump",
    backgroundColor: "#9B59B6"
  },
  {
    label: "Brake Failure",
    key: "brakeFailure",
    backgroundColor: "#E74C3C"
  },
  {
    label: "Slip/Slide Detected",
    key: "slipSlideDetected",
    backgroundColor: "#00A6A6"
  },
  {
    label: "Train Length Change",
    key: "trainLengthChange",
    backgroundColor: "#546E7A"
  },
  {
    label: "Rollback",
    key: "rollback",
    backgroundColor: "#8B0000"
  },
  {
    label: "Rollaway",
    key: "rollaway",
    backgroundColor: "#e5cfc0"
  },
  {
    label: "Signal Blanking",
    key: "signalBlanking",
    backgroundColor: "#F4D03F"
  },
  {
    label: "System Failure",
    key: "systemFailure",
    backgroundColor: "#2ECC71"
  },
  {
    label: "Sudden Drop In Ma",
    key: "suddenDropInMa",
    backgroundColor: "#7A8B2E"
  },

  // ---- Events where KT not given ----

  // {
  //   label: "RF Reception Monitoring",
  //   key: "rfReceptionMonitoring",
  //   backgroundColor: "#F4D03F"
  // },
  // {
  //   label: "SOC - Movement Authority Fluctuations",
  //   key: "socMovementAuthorityFluctuations",
  //   backgroundColor: "#AF7AC5"
  // },
  // {
  //   label: "All SOS Scenario",
  //   key: "allSosScenario",
  //   backgroundColor: "#EC7063"
  // }
];

export const HEALTH_CATEGORIES = [
  // {
  //   label: "Radio - RF Issues",
  //   key: "radioRfIssues",
  //   value: 24,
  //   backgroundColor: "#FF6B6B"
  // },
  {
    label: "Card Status",
    key: "cardStatus",
    backgroundColor: "#F18226"
  },
  {
    label: "DMI Health Monitoring",
    key: "dmiHealthMonitoring",
    value: 14,
    backgroundColor: "#F4A6B8"
  },
  {
    label: "Crash Logs",
    key: "crashLogs",
    value: 18,
    backgroundColor: "#8B0000"
  },
  {
    label: "Brake Failure",
    key: "brakeFailure",
    backgroundColor: "#E74C3C"
  },
  {
    label: "Speedometer Health Monitoring",
    key: "speedometerHealthMonitoring",
    value: 6,
    backgroundColor: "#7F7F7F"
  },
  {
    label: "Card Diagnostics",
    key: "cardDiagnostics",
    value: 16,
    backgroundColor: "#6FA8DC"
  },
  {
    label: "Reader Efficiency",
    key: "readerEfficiency",
    value: 8,
    backgroundColor: "#9B59B6"
  },
  {
    label: "Radio Parameters Monitoring",
    key: "radioParametersMonitoring",
    value: 8,
    backgroundColor: "#2ECC71"
  },
];

export const REPORT_TYPES = {
  HEADER: {
    LOCO_HEALTH: {
      READER_EFFICENCY: "Reader Efficiency",
      RF_ISSUES_LOCO: "Radio - RF Issues",
      CARD_STATUS: "Card Status",
      BRAKE_VC_LOGS_MONITORING: "Brake Failure",
      CARD_DIAGNOSTICS: "Card Diagnostics",
      DMI_HEALTH_MONITORING: "DMI Health Monitoring",
      SPEEDOMETER_HEALTH_MONITORING: "Speedometer Health Monitoring",
      CRASH_LOGS: "Crash Logs",
      RADIO_PARAMETERS_MONITORING: "Radio Parameters Monitoring",
      CHECKSUM_CHANGE_REPORT: "Checksum Change",
      CAB_RFID_READER: "Cab & RFID Reader Monitoring",
    },
    STATION_HEALTH: {
      EIGW_FAILURE: "EIGW Failures",
      S2S_LINK_FAILURE: "S2S Link Failure",
      RF_ISSUES_STATION: "Radio - RF Issues",
      CARD_STATUS: "Card Status",
      CARD_DIAGNOSTICS: "Card Diagnostics",
      RADIO_PARAMETERS_MONITORING: "Radio Parameters Monitoring",
      CHECKSUM_CHANGE_REPORT: "Checksum Change",
      FIU: "FIU",
      CRASH_LOGS: "Crash Logs",
      SYSTEM_FAILURE: "System Failure",
      CHANGEOVER_OF_CARDS: "Changeover of Cards",
      RIU: "RIU",
      SIGNAL_ASPECT_BLANKING: "Signal Raw Aspect Blanking",
      MONITORING_BOOT_LOGS: "Monitoring Boot Logs"
    },
    EVENTS: {
      TAG_MISSING: "Tag Missing",
      TAG_MISSING_NEW: "Tag Missing New",
      UNWANTED_BRAKING: "Undesirable Braking",
      SIGNAL_BLANKING: "Signal Blanking",
    }
  },
  PARAMS: {
    LOCO_HEALTH: {
      READER_EFFICENCY: "Reader Efficiency",
      RF_ISSUES_LOCO: "Radio Health",
      CARD_STATUS: "Card Status",
      BRAKE_VC_LOGS_MONITORING: "Brake Failure",
      CARD_DIAGNOSTICS: "Card Diagnostics",
      DMI_HEALTH_MONITORING: "DMI Health",
      SPEEDOMETER_HEALTH_MONITORING: "Speedometer Health",
      CRASH_LOGS: "Crash Detected",
      RADIO_PARAMETERS_MONITORING: "Radio Health Detected",
      CHECKSUM_CHANGE_REPORT: "Checksum Change Report",
      CAB_RFID_READER: "CAB READER MISMATCH",
    },
    STATION_HEALTH: {
      EIGW_FAILURE: "Station EIGW Failure Detected",
      S2S_LINK_FAILURE: "Station S2S Failure",
      RF_ISSUES_STATION: "Station Health",
      CARD_STATUS: "Station Card Status Detected",
      CARD_DIAGNOSTICS: "Station Card Diagnostic Detected",
      RADIO_PARAMETERS_MONITORING: "Station Radio Health Detected",
      CHECKSUM_CHANGE_REPORT: "Station Checksum Change",
      FIU: "Station FIU Detected",
      CRASH_LOGS: "Station Crash Detected",
      SYSTEM_FAILURE: "Station System Failure",
      CHANGEOVER_OF_CARDS: "Station Change of Cards",
      RIU: "Station RIU Status Detected",
      SIGNAL_ASPECT_BLANKING: "Station Signal Blanking",
      MONITORING_BOOT_LOGS: "Station Boot Log Detected"
    },
    EVENTS: {
      TAG_MISSING: "Tag Missing",
      TAG_MISSING_NEW: "Tag Missing New",
      UNWANTED_BRAKING: "Undesirable Braking",
      SIGNAL_BLANKING: "Signal Blanking",
    }
  },
}

export const REPORT_TYPES_DESCRIPTION = {
  LOCO_HEALTH: {
    READER_EFFICENCY: "This report provides a comparative analysis of RFID Reader performance based on Tag Read count to identify dominant or degraded readers.",
    RF_ISSUES_LOCO: "This report analyses RF communication health at the loco level by comparing Tx and Rx RRL file sizes across multiple radios to identify degraded or failed radios.",
    CARD_STATUS: "This report provides insights into the operational health, connectivity, and functionality of the on-board Kavach cards installed inside a locomotive.",
    BRAKE_VC_LOGS_MONITORING: "This report provides insights into brake-related faults on the locomotive by analyzing Brake VC logs and identifying brake failures and abnormal conditions that may impact safe train operation.",
    CARD_DIAGNOSTICS: "This report shows diagnostic data from the locomotive's Kavach cards, enabling early detection of card issues, error patterns, and hardware degradation.",
    DMI_HEALTH_MONITORING: "This report provides insights into the operational and communication health of the Driver Machine Interface (DMI) by identifying faults, isolate conditions, and restart events that may impact loco operation.",
    SPEEDOMETER_HEALTH_MONITORING: "This Report provides insights into the operational health of the locomotive speedometer systems by identifying critical states and communication failures that may impact accurate speed measurement.",
    CRASH_LOGS: "This report captures crash events detected from loco logs, highlighting system failures and their occurrence timestamps for analysis.",
    RADIO_PARAMETERS_MONITORING: "This report monitors the health of locomotive radio communication by detecting failures and recovery events.",
    CHECKSUM_CHANGE_REPORT: "This report provides insights into checksum and software changes across VC and DMI systems, helping identify configuration updates, software changes, and reset events impacting loco operations.",
    CAB_RFID_READER: "This report monitors the communication status of the cab and the performance of RFID readers, identifying connectivity issues, reader failures, and inconsistencies in tag detection to ensure reliable system operation.",
  },

  STATION_HEALTH: {
    RF_ISSUES_STATION: "This report analyses RF communication health at the station level by comparing Tx and Rx RRL file sizes across multiple radios to identify degraded or failed radios.",
    CARD_STATUS: "This report provides insights into the operational health, connectivity, and functionality of the station Kavach cards installed inside a station.",
    CARD_DIAGNOSTICS: "This report shows diagnostic data from the station Kavach cards, enabling early detection of card issues, error patterns, and hardware degradation.",
    RADIO_PARAMETERS_MONITORING: "This report monitors the health of station radio communication by detecting failures and recovery events.",
    CHECKSUM_CHANGE_REPORT: "This report provides insights into checksum and software changes across VC and SVGW systems, helping identify configuration updates, software changes, and reset events impacting station operations.",
    FIU: "This report provides insights into FIU (Field Input Unit) health by tracking error and recovery transitions, enabling identification of communication failures, hardware instability, and restoration events across station systems.",
    CRASH_LOGS: "This report captures crash events detected from loco logs, highlighting system failures and their occurrence timestamps for analysis.",
    S2S_LINK_FAILURE: "This report provides insights into Station-to-Station (S2S) communication health by analyzing gateway and adjacent station link statuses, detecting failure and recovery transitions.",
    EIGW_FAILURE: "This report provides insights into EI Gateway and EI communication health by analyzing card status logs, detecting failure and recovery transitions.",
    SYSTEM_FAILURE: "This report identifies and classifies system failures from SMI logs, helping detect configuration issues, hardware faults, and synchronization behavior across station components.",
    CHANGEOVER_OF_CARDS: "This report monitors card health and detects changeovers by tracking state transitions across system components.",
    RIU: "This report monitors state transitions and captures key events, highlighting undefined patterns for further analysis.",
    SIGNAL_ASPECT_BLANKING: "This report monitors signal state transitions and identifies blanking events based on changes in signal aspects.",
    MONITORING_BOOT_LOGS: "This report enables you to monitor Station TCAS restart events and analyse the application versions active at the time of restart."
  },

  EVENTS: {
    TAG_MISSING: "This report enables you to identify instances where mandatory trackside tags were not successfully read during train operation, along with the associated location and time details for analysis.",
    TAG_MISSING_NEW: "",
    UNWANTED_BRAKING: "This report enables you to analyse instances of forced or emergency braking events along with their operational context to support safely review and analysis.",
    SIGNAL_BLANKING: "This report identifies signal blanking instances based on DMI Display logs where signal information is unavailable due to RF loss or override."
  }
};

export const READER_EFFICIENCY_REPORT_DATA: READER_EFFICIENCY_REPORT[] = [
  {
    locoId: 6398,
    reader1Count: "150",
    reader2Count: "120",
    rfIdReaderStatus: "Reader-1 -> Reader-2 by 20% or more",
    tripId: 482736,
    tripStart: "28/01/2026, 10:00:00",
    tripEnd: "28/01/2026, 16:50:00",
    tripStatus: 'Open'
  },
  {
    locoId: 6399,
    reader1Count: "15",
    reader2Count: "110",
    rfIdReaderStatus: "Good",
    tripId: 482738,
    tripStart: "29/01/2026, 10:00:00",
    tripEnd: "29/01/2026, 16:50:00",
    tripStatus: 'Open'
  }
]

export const CAB_RFID_READER_REPORT_DATA: CAB_RFID_READER_REPORT[] = [
  {
    locoId: 6398,
    activeCab: 1,
    expectedReader: 1,
    actualReader: 12,
    actualReaderSequence: "1,1,12",
    timestamp: "28/01/2026, 16:50:00",
    tripId: 482736,
    tripStart: "28/01/2026, 10:00:00",
    tripEnd: "28/01/2026, 16:50:00",
    tripStatus: 'Open'
  },
  {
    locoId: 6399,
    activeCab: 2,
    expectedReader: 2,
    actualReader: 1,
    actualReaderSequence: "2,2,1",
    timestamp: "29/01/2026, 16:50:00",
    tripId: 482738,
    tripStart: "29/01/2026, 10:00:00",
    tripEnd: "29/01/2026, 16:50:00",
    tripStatus: 'Open'
  }
]

export const SIGNAL_BLANKING_REPORT_DATA: SIGNAL_BLANKING_REPORT[] = [
  {
    locoId: 6398,
    eventId: '28',
    stationId: 4582,
    cardId: "33445",
    tcasMode: "1",
    rfSignalStrength: 0,
    timestamp: "28/01/2026, 16:50:00",
    tripId: 132355,
    tripStart: "28/01/2026, 10:00:00",
    tripEnd: "28/01/2026, 16:50:00",
    signalType: 1,
    signalAspect: 2,
    syncStatus: "NA"
  },
  {
    locoId: 6399,
    stationId: 4682,
    eventId: '28',
    cardId: "33545",
    tcasMode: "1",
    rfSignalStrength: 0,
    timestamp: "29/01/2026, 16:50:00",
    tripId: 246465,
    tripStart: "29/01/2026, 10:00:00",
    tripEnd: "29/01/2026, 16:50:00",
    signalType: 2,
    signalAspect: 4,
    syncStatus: "NA"
  }
]

export const RF_ISSUES_STATION_REPORT_DATA: RF_ISSUES_STATION_REPORT[] = [
  {
    stationId: 4582,
    radioId: "1",
    locoId: 6398,
    transmissionMode: "Tx",
    variation: 25,
    rating: "Warning",
    date: "28/01/2026"
  },
  {
    stationId: 4682,
    radioId: "2",
    locoId: 6399,
    transmissionMode: "Rx",
    variation: 15,
    rating: "Bad",
    date: "29/01/2026"
  }
]

export const RF_ISSUES_LOCO_REPORT_DATA: RF_ISSUES_LOCO_REPORT[] = [
  {
    radioId: "1",
    locoId: 6398,
    transmissionMode: "Tx",
    variation: 30,
    rating: "Bad",
    date: "28/01/2026",
    tripId: 132355,
    tripStart: "28/01/2026, 10:00:00",
    tripEnd: "28/01/2026, 16:50:00"
  },
  {
    radioId: "2",
    locoId: 6399,
    transmissionMode: "Rx",
    variation: 10,
    rating: "Warning",
    date: "29/01/2026",
    tripId: 246465,
    tripStart: "29/01/2026, 10:00:00",
    tripEnd: "29/01/2026, 16:50:00"
  }
]

export const CARD_STATUS_REPORT_DATA: CARD_STATUS_REPORT[] = [
  {
    locoId: 6398,
    stationId: 1234,
    controllerName: "PPC1-P1",
    transitionType: "Recovery",
    transitionPattern: "G->F",
    timestamp: "28/01/2026, 10:00:00",
    tripId: 13235,
    tripStart: "28/01/2026, 10:00:00",
    tripEnd: "28/01/2026, 16:50:00",
    tripStatus: 'Open'
  },
  {
    locoId: 6399,
    stationId: 1234,
    tripId: 24646,
    controllerName: "PPC2-P1",
    transitionType: "Event",
    transitionPattern: "G->F",
    timestamp: "29/01/2026, 10:00:00",
    tripStart: "29/01/2026, 10:00:00",
    tripEnd: "29/01/2026, 16:50:00",
    tripStatus: 'Open'
  }
]

export const BRAKE_VC_LOGS_MONITORING_REPORT_DATA: BRAKE_VC_LOGS_MONITORING_REPORT[] = [
  {
    locoId: 6398,
    sbp: 1234,
    faultCode: 456,
    faultDescription: "Brake Failure",
    faultType: 1,
    tripId: 132355,
    timestamp: "28/01/2026, 16:50:00",
    tripStart: "28/01/2026, 10:00:00",
    tripEnd: "28/01/2026, 16:50:00",
    tripStatus: 'Open'
  },
  {
    locoId: 6399,
    sbp: 1235,
    faultCode: 457,
    faultDescription: "Brake Valve Issue",
    faultType: 2,
    tripId: 246465,
    timestamp: "29/01/2026, 16:50:00",
    tripStart: "29/01/2026, 10:00:00",
    tripEnd: "29/01/2026, 16:50:00",
    tripStatus: 'Open'
  }
]

export const DMI_HEALTH_MONITORING_REPORT_DATA: DMI_HEALTH_MONITORING_REPORT[] = [
  {
    locoId: 9265,
    tripId: 857392,
    dmiACommOk: 1,
    dmiAHealth: 1,
    dmiBCommOk: 1,
    dmiBHealth: 1,
    transitionType: '-',
    transitionPattern: "G->F",
    healthStatus: "All Healthy",
    timestamp: "29/01/2026, 16:50:00",
    tripStart: "29/01/2026, 10:00:00",
    tripEnd: "29/01/2026, 16:50:00",
    tripStatus: 'Open'
  },
  {
    locoId: 9266,
    tripId: 857393,
    dmiACommOk: 0,
    dmiAHealth: 0,
    dmiBCommOk: 1,
    dmiBHealth: 1,
    transitionType: '-',
    transitionPattern: "G->F",
    healthStatus: "DMI A Unhealthy",
    timestamp: "29/01/2026, 15:30:45",
    tripStart: "29/01/2026, 10:00:00",
    tripEnd: "29/01/2026, 16:50:00",
    tripStatus: 'Open'
  }
];

export const SPEEDOMETER_HEALTH_MONITORING_REPORT_DATA: SPEEDOMETER_HEALTH_MONITORING_REPORT[] = [
  {
    locoId: 9265,
    tripId: 857392,
    c1Cog: 1,
    c2Cog: 7,
    c1CogDescription: "Full Operating Grade Level",
    c2CogDescription: "Fatal Error",
    healthStatus: "Speedometer 1 & 2 Healthy",
    timestamp: "14:30:45, 05-11-2026",
    tripStart: "14:30:45, 05-11-2026",
    tripEnd: "15:30:45, 05-11-2026",
    c2CogTransitionPattern: '',
    c1CogTransitionPattern: '',
    tripStatus: 'Open'
  },
  {
    locoId: 9266,
    tripId: 857393,
    c1Cog: 1,
    c2Cog: 7,
    c1CogDescription: "Full Operating Grade Level",
    c2CogDescription: "Fatal Error",
    healthStatus: "Speedometer 1 & 2 Unhealthy",
    timestamp: "15:30:45, 05-11-2026",
    tripStart: "14:30:45, 05-11-2026",
    tripEnd: "15:30:45, 05-11-2026",
    c2CogTransitionPattern: '',
    c1CogTransitionPattern: '',
    tripStatus: 'Open'
  }
];

export const S2S_LINK_FAILURE_REPORT_DATA: S2S_LINK_FAILURE_REPORT[] = [
  {
    stationId: 6398,
    adjacentStationId: 1234,
    transitionType: "Link Failure",
    failureReason: "Signal Loss",
    timestamp: "29/01/2026, 15:30:45"
  },
  {
    stationId: 6399,
    adjacentStationId: 1234,
    transitionType: "Link Failure",
    failureReason: "Signal Loss",
    timestamp: "29/01/2026, 15:30:45"
  }
];

export const EIGW_FAILURE_REPORT_DATA: EIGW_FAILURE_REPORT[] = [
  {
    stationId: 6398,
    eiIndex: 1234,
    transitionType: "Link Failure",
    failureReason: "Signal Loss",
    timestamp: "29/01/2026, 15:30:45"
  },
  {
    stationId: 6399,
    eiIndex: 1234,
    transitionType: "Link Failure",
    failureReason: "Signal Loss",
    timestamp: "29/01/2026, 15:30:45"
  }
];

export const CARD_DIAGNOSTICS_REPORT_DATA: CARD_DIAGNOSTICS_REPORT[] = [
  {
    locoId: 9265,
    stationId: 1234,
    tripId: 8573,
    card: "VcA-Pic",
    errorsType: "CheckSum",
    options: "F8B00702",
    timestamp: "18:10:45, 01-02-2026",
    tripStart: "18:10:45, 01-02-2026",
    tripEnd: "18:50:45, 01-02-2026",
    tripStatus: 'Open'
  },
  {
    locoId: 5830,
    tripId: 9153,
    stationId: 1234,
    card: "VcB-Pic",
    errorsType: "RAM Fail",
    options: "F8B00702",
    timestamp: "19:25:12, 01-03-2026",
    tripStart: "19:25:12, 01-03-2026",
    tripEnd: "20:05:12, 01-03-2026",
    tripStatus: 'Open'
  }
];

export const FIND_TRIPS_REPORT_DATA: FIND_TRIPS_REPORT[] = [
  {
    tripId: 6398,
    tripStart: "14:30:45, 05-11-2023",
    tripEnd: "03:00:00, 14-07-2023",
    rfIssuesLoco: 39,
    crashLogs: 53,
    cardDiagnostics: 72,
    dmiHealthMonitoring: 54,
    locoId: 9265,
    modeDegradation: 5,
    tagMissing: 1,
    undesirableBraking: 2,
    signalBlanking: 3,
    readerEfficiency: 1
  },
  {
    tripId: 4789,
    tripStart: "09:15:22, 12-03-2024",
    tripEnd: "21:45:30, 10-10-2024",
    rfIssuesLoco: 63,
    crashLogs: 85,
    cardDiagnostics: 66,
    dmiHealthMonitoring: 11,
    locoId: 9265,
    modeDegradation: 4,
    tagMissing: 1,
    undesirableBraking: 2,
    signalBlanking: 3,
    readerEfficiency: 1
  }
];

export const CRASH_LOGS_REPORT_DATA: CRASH_LOGS_REPORT[] = [
  {
    locoId: 9265,
    stationId: 1234,
    tripId: 6384,
    tripStart: "07:15:22, 18-03-2024",
    tripEnd: "11:45:59, 29-09-2023",
    sourceId: "17",
    packetSource: "1",
    masterSlave: "17",
    errorType: "Warning",
    timestamp: "12:00:00, 01-01-2024",
    tripStatus: 'Open'
  },
  {
    locoId: 5830,
    stationId: 1234,
    tripId: 2957,
    tripStart: "02:59:10, 01-05-2024",
    tripEnd: "16:20:33, 22-12-2023",
    sourceId: "90",
    packetSource: "1",
    masterSlave: "90",
    errorType: "Worst",
    timestamp: "18:30:45, 01-02-2024",
    tripStatus: 'Open'
  }
];

export const HBL_PA_RESOURCES = {
  // Main
  EVENTS: "Events",
  HEALTH: "Health",
  TRIP_SUMMARY: "Trip Summary",
  REPORT: "Reports",
  FIND_TRIPS: "Find Trips",
  USERMGMT: "User Management",
  CUSTOMER: "Customer",
  HBL_PA: "HBL Performance Analysis",

  //EVENTS
  LOCO_EVENTS: "Events_Loco",
  STATION_EVENTS: "Events_Station",

  // Health
  LOCO_HEALTH: "Health_Loco",
  STATION_HEALTH: "Health_Station",
  RADIO_HEALTH: "Health_Radio",

  // Events (Reports)
  EVENTS_REPORT: "Reports_Events",
  EVENTS_TAG_MISSING: "Reports_Events_Tag Missing",
  EVENTS_TAG_MISSING_NEW: "Reports_Events_Tag Missing New",
  EVENTS_UNWANTED_BRAKING: "Reports_Events_Undesirable Braking",
  EVENTS_SIGNAL_BLANKING: "Reports_Events_Signal Blanking",

  // Loco Health Reports
  LOCO_REPORT: "Reports_Loco Health",
  LOCO_READER_EFFICIENCY: "Reports_Loco Health_Reader Efficiency",
  LOCO_CHECKSUM_CHANGE: "Reports_Loco Health_Checksum Change",
  LOCO_SPEEDOMETER_HEALTH_MONITORING: "Reports_Loco Health_Speedometer Health Monitoring",
  LOCO_CARD_STATUS: "Reports_Loco Health_Card Status",
  LOCO_CARD_DIAGNOSTICS: "Reports_Loco Health_Card Diagnostics",
  LOCO_DMI_HEALTH_MONITORING: "Reports_Loco Health_DMI Health Monitoring",
  LOCO_RF_ISSUES: "Reports_Loco Health_Radio - RF Issues",
  LOCO_BRAKE_VC_LOGS_MONITORING: "Reports_Loco Health_Brake Failure",
  LOCO_CRASH_LOGS: "Reports_Loco Health_Crash Logs",
  LOCO_RADIO_PARAMETERS_MONITORING: "Reports_Loco Health_Radio Parameters Monitoring",
  LOCO_CAB_RFID_READER: "Reports_Loco Health_Cab & RFID Reader Monitoring",

  // Station Health Reports
  STATION_REPORT: "Reports_Station Health",
  STATION_RF_ISSUES: "Reports_Station Health_Radio - RF Issues",
  STATION_S2S_LINK_FAILURE: "Reports_Station Health_S2S Link Failure",
  STATION_EIGW_FAILURE: "Reports_Station Health_EIGW Failures",
  STATION_FIU: "Reports_Station Health_FIU",
  STATION_CARD_STATUS: "Reports_Station Health_Card Status",
  STATION_CARD_DIAGNOSTICS: "Reports_Station Health_Card Diagnostics",
  STATION_RADIO_PARAMETERS_MONITORING: "Reports_Station Health_Radio Parameters Monitoring",
  STATION_CHECKSUM_CHANGE: "Reports_Station Health_Checksum Change",
  STATION_CRASH_LOGS: "Reports_Station Health_Crash Logs",
  STATION_SYSTEM_FAILURE: "Reports_Station Health_System Failure",
  STATION_CHANGEOVER_OF_CARDS: "Reports_Station Health_Changeover of Cards",
  STATION_RIU: "Reports_Station Health_RIU",
  STATION_SIGNAL_ASPECT_BLANKING: "Reports_Station Health_Signal Raw Aspect Blanking",
  STATION_MONITORING_BOOT_LOGS: "Reports_Station Health_Monitoring Boot Logs",

  STATION_METADATA: "Station Metadata",

  UNIFIED_KPI: "Unified KPI",
};

export const HEALTH_TIMELINE: HEALTH_TIMELINE_TABLE[] = [
  {
    locoId: '6398',
    parameter: 'RF Issues',
    status: 'Warning',
    timestamp: '05:17:54, 30-08-2026',
    path: '/report/loco-health/rf-issues-loco'
  },
  {
    locoId: '6398',
    parameter: 'Card Status',
    status: 'Error',
    timestamp: '08:52:11, 14-07-2025',
    path: "/report/loco-health/card-status"
  },
  {
    locoId: '6398',
    parameter: 'DMI Health',
    status: 'DMI A Unhealthy',
    timestamp: '16:39:22, 03-01-2026',
    path: "/report/loco-health/dmi-health-monitoring"
  }
];

export const HEALTH_TYPE_DESCRIPTION = {
  LOCO: 'This page will give you a clear view of a particular Loco in respective to Events and Health',
  STATION: 'This page will give you a clear view of a particular station in respective to Events and Health'
}

export const CARD_DIAGNOSTIC_HEALTH_DATA: CARD_DIAGNOSTICS_HEALTH[] = [
  {
    card: "VcA - Pic",
    error: "CheckSum",
    timestamp: "07:03:36, 23-10-2024"
  },
  {
    card: "VcB - Pic",
    error: "SrErrConReset",
    timestamp: "21:31:03, 15-01-2025"
  }
];

export const BRAKE_VC_LOGS_MONITORING_HEALTH_DATA: BRAKE_VC_LOGS_MONITORING_HEALTH[] = [
  {
    faultType: "Normal Valve Fault",
    faultCode: "Valve 2",
    timestamp: "05:17:54, 30-08-2026"
  },
  {
    faultType: "SA9 EPC fatal error",
    faultCode: "0",
    timestamp: "08:52:11, 14-07-2025"
  }
];

export const RADIO_PARAMETERS_MONITORING_REPORT_DATA: RADIO_PARAMETERS_MONITORING_REPORT[] = [
  {
    locoId: 12045,
    stationId: 1234,
    tripId: 1001,
    timestamp: "16:39:22, 03-01-2026",
    tripStart: "07:15:22, 18-03-2024",
    tripEnd: "11:45:59, 29-09-2023",
    activeController: "Controller A",
    transitionPattern: "A → B",
    transitionType: "Error",
    radio: "A",
    tripStatus: 'Open'
  },
  {
    locoId: 12045,
    stationId: 1234,
    tripId: 1001,
    timestamp: "16:39:22, 03-01-2026",
    activeController: "Controller B",
    tripStart: "07:15:22, 18-03-2024",
    tripEnd: "11:45:59, 29-09-2023",
    transitionPattern: "B → A",
    transitionType: "Recovery",
    radio: "B",
    tripStatus: 'Open'
  }
];

export const CHECKSUM_CHANGE_REPORT_DATA: CHECKSUM_CHANGE_REPORT[] = [
  {
    timestamp: '17:06:25',
    vcSource: 'VC1',
    vcVersion: '4.0.28',
    vcChangeType: 'No Change',
    dmiVersion: '4.0.9',
    dmi1ChangeType: 'No Change',
    changeSource: 'None',
    dmi1Source: 'dmi2',
    dmi2ChangeType: 'Invalid',
    dmi2Source: 'dmi1',
    tripStatus: 'Open'
  },
  {
    timestamp: '17:11:41',
    vcSource: 'VC2',
    vcVersion: '4.0.28',
    vcChangeType: 'Executive SW Changed',
    dmiVersion: '4.0.9',
    dmi1ChangeType: 'No Change',
    changeSource: 'VC',
    dmi1Source: 'dmi1',
    dmi2ChangeType: 'Invalid',
    dmi2Source: 'dmi1',
    tripStatus: 'Open'
  },
  {
    timestamp: '17:13:25',
    vcSource: 'VC3',
    vcVersion: '0.0.0',
    vcChangeType: 'Reset Detected',
    dmiVersion: '4.0.9',
    changeSource: 'Both',
    dmi1ChangeType: 'Invalid',
    dmi1Source: 'dmi1',
    dmi2ChangeType: 'Invalid',
    dmi2Source: 'dmi1',
    tripStatus: 'Open'
  }
];

export const FIU_REPORT_DATA: FIU_REPORT[] = [
  {
    stationId: 1234,
    timestamp: "16:39:22, 03-01-2026",
    contactNo: "1234",
    transitionPattern: "A → B",
    transitionType: "Error",
    cardId: '1'
  },
  {
    stationId: 1234,
    timestamp: "16:39:22, 03-01-2026",
    contactNo: "2432",
    transitionPattern: "B → A",
    transitionType: "Recovery",
    cardId: '1'
  }
];

export const SYSTEM_FAILURE_REPORT_DATA: SYSTEM_FAILURE_REPORT[] = [
  {
    timestamp: '2026-03-30 12:45:50',
    stationId: 'STN-003',
    failureMessage: 'Invalid configuration file',
    failureType: 'Config',
    failureComponents: 'Firmware',
    syncStatus: 'Failed',
    cardId: 1
  },
  {
    timestamp: '2026-03-30 13:20:05',
    stationId: 'STN-004',
    failureMessage: 'Peripheral communication timeout',
    failureType: 'Peripheral',
    failureComponents: 'Communication Bus',
    syncStatus: 'Synced',
    cardId: 1
  },
  {
    timestamp: '2026-03-30 14:10:42',
    stationId: 'STN-005',
    failureMessage: 'Checksum validation failed',
    failureType: 'Config',
    failureComponents: 'Memory Unit',
    syncStatus: 'Failed',
    cardId: 1
  }
];

export const CHANGEOVER_OF_CARDS_REPORT_DATA: CHANGEOVER_OF_CARDS_REPORT[] = [
  {
    stationId: 1234,
    activeBm: 'BM1',
    bmStatus: 1,
    activeCan: 2,
    bmState: 1,
    transitionPattern: 'Pattern A',
    transitionType: 'Auto',
    timestamp: '2026-04-01T10:30:00'
  },
  {
    stationId: 1234,
    activeBm: 'BM2',
    bmStatus: 1,
    activeCan: 1,
    bmState: 2,
    transitionPattern: 'Pattern B',
    transitionType: 'Manual',
    timestamp: '2026-04-01T11:00:00'
  }
];

export const RIU_REPORT_DATA: RIU_REPORT[] = [
  {
    stationId: 1234,
    timestamp: "16:39:22, 03-01-2026",
    nodeId: 3245,
    cardId: 5432,
    transitionPattern: "A → B",
    transitionType: "Error",
    healthCode: 'C1',
    nodeCount: '2'
  },
  {
    stationId: 1234,
    timestamp: "16:39:22, 03-01-2026",
    nodeId: 5678,
    cardId: 8765,
    transitionPattern: "B → A",
    transitionType: "Recovery",
    healthCode: 'C1',
    nodeCount: '2'
  }
];

export const LOCO_HEALTH_CHART = {
  DMI_CATEGORIES: [
    { key: 'dmiAUnhealthy', label: 'DMI A Unhealthy', backgroundColor: '#7C6EE6' },
    { key: 'dmiBUnhealthy', label: 'DMI B Unhealthy', backgroundColor: '#F17C72' },
    { key: 'bothUnhealthy', label: 'Both Unhealthy', backgroundColor: '#3DB1C2' }
  ],
  RF_CATEGORIES: [
    { key: 'txIssueCount', label: 'Tx', backgroundColor: '#3B82F6' },
    { key: 'rxIssueCount', label: 'Rx', backgroundColor: '#ff2db2' }
  ],
  SPEEDOMETER_CATEGORIES: [
    { key: 'speedometer1Unhealthy', label: 'Speedometer 1 Unhealthy', backgroundColor: '#7C6EE6' },
    { key: 'speedometer2Unhealthy', label: 'Speedometer 2 Unhealthy', backgroundColor: '#F17C72' },
    { key: 'bothUnhealthy', label: 'Both Unhealthy', backgroundColor: '#3DB1C2' }
  ],
  READER_EFFICIENCY: [
    { key: 'reader1Count', label: 'Reader 1 Count', backgroundColor: '#7C6EE6' },
    { key: 'reader2Count', label: 'Reader 2 Count', backgroundColor: '#F17C72' }
  ]
}

export const STATION_HEALTH_CHART = {
  SIGNAL_ASPECT_BLANKING: [
    { key: 'recoveryCount', label: 'Recovery', backgroundColor: '#7C6EE6' },
    { key: 'blankingCount', label: 'Blanking', backgroundColor: '#ff2db2' }
  ],
  RF_CATEGORIES: [
    { key: 'txIssueCount', label: 'Tx', backgroundColor: '#3B82F6' },
    { key: 'rxIssueCount', label: 'Rx', backgroundColor: '#ff2db2' }
  ],
  CARD_STATUS: [
    { key: 'error', label: 'Error', backgroundColor: '#F17C72' },
    { key: 'degraded', label: 'Degraded', backgroundColor: '#7C6EE6' },
    { key: 'partialRecovery', label: 'Partial Recovery', backgroundColor: '#F4A742' },
    { key: 'fullRecovery', label: 'Full Recovery', backgroundColor: '#3DB1C2' },
    // { key: 'defaultTransition', label: 'Default Transition', backgroundColor: '#ff2db2' },
    // { key: 'standBy', label: 'Stand By', backgroundColor: '#3B82F6' }
  ]
}

export const SIGNAL_ASPECT_BLANKING_REPORT_DATA: SIGNAL_ASPECT_BLANKING_REPORT[] = [
  {
    stationId: 1234,
    signalId: 'BM1',
    signalColumn: '',
    transitionPattern: 'Pattern A',
    eventType: 'Auto',
    timestamp: '2026-04-01T10:30:00'
  },
  {
    stationId: 1234,
    signalId: 'BM2',
    signalColumn: '',
    transitionPattern: 'Pattern B',
    eventType: 'Manual',
    timestamp: '2026-04-01T11:00:00'
  }
];

export const MONITORING_BOOT_LOGS_REPORT_DATA: MONITORING_BOOT_LOGS_REPORT[] = [
  {
    stationId: 1234,
    application: 'BM1',
    version: 'Pattern A',
    timestamp: '2026-04-01T10:30:00'
  },
  {
    stationId: 1234,
    application: 'BM1',
    version: 'Pattern A',
    timestamp: '2026-04-01T11:00:00'
  }
];

export const FILTERS_STORAGE_KEY = "dashboardFilters";

export const FIND_TRIPS_PAGINATOR_KEY = "findTripsPaginator";

export const RCA_BACK_BUTTON = "rcaBackButton";

export const FIND_TRIPS_TIME = "findTripsTime";

export const STATION_METADATA_DATA: STATION_METADATA[] = [
  {
    stationId: 1234,
    stationName: "Central Station",
    zone: "Zone A",
    lastUpdated: "2026-04-01T10:30:00",
    updatedBy: "Admin"
  }
]

export const STATION_EVENTS_FILTERS = "stationEventsFilters";

export const STATION_EVENTS_CATEGORIES = [
  // {
  //   label: "Checksum",
  //   key: "checksum",
  //   backgroundColor: "#F18226"
  // },
  // {
  //   label: "Boot Log",
  //   key: "bootLog",
  //   backgroundColor: "#3B8AD9"
  // },
  {
    label: "Undesirable Braking",
    key: "undesirableBraking",
    backgroundColor: "#F18226"
  },
  {
    label: "Mode Degradation",
    key: "modeDegradation",
    backgroundColor: "#3B8AD9"
  },
  {
    label: "Station Soc MA",
    key: "stationSocMa",
    backgroundColor: "#9B59B6"
  },
  // {
  //   label: "Card Diagnostic",
  //   key: "cardDiagnostic",
  //   backgroundColor: "#7BC0F7"
  // },
  // {
  //   label: "Card Status",
  //   key: "cardStatus",
  //   backgroundColor: "#9B59B6"
  // },
  // {
  //   label: "Change Over Card",
  //   key: "changeOverCard",
  //   backgroundColor: "#E74C3C"
  // },
  // {
  //   label: "Crash Log",
  //   key: "crashLog",
  //   backgroundColor: "#16A085"
  // },
  // {
  //   label: "EIGW",
  //   key: "eigw",
  //   backgroundColor: "#546E7A"
  // },
  // {
  //   label: "FIU",
  //   key: "fiu",
  //   backgroundColor: "#8B0000"
  // },
  // {
  //   label: "Radio Parameter",
  //   key: "radioParameter",
  //   backgroundColor: "#E67E22"
  // },
  // {
  //   label: "RIU",
  //   key: "riu",
  //   backgroundColor: "#2E86C1"
  // },
  // {
  //   label: "S2S",
  //   key: "s2s",
  //   backgroundColor: "#27AE60"
  // },
  // {
  //   label: "Signal Raw Aspect Blanking",
  //   key: "signalRawAspectBlanking",
  //   backgroundColor: "#F4D03F"
  // },
  // {
  //   label: "System Failure",
  //   key: "systemFailure",
  //   backgroundColor: "#2ECC71"
  // }
];

export const TAG_MISSING_NEW_REPORT_DATA: TAG_MISSING_NEW_REPORT[] = [
  {
    locoId: 6398,
    stationId: 6243,
    previousReadTag: 482,
    categoryOfTag: "Main Tag",
    missedTag: 456,
    timesMissed: 2,
    locosThatMissed: 224,
    absoluteLocation: 482736,
    eventCategory: "Physical Tag Miss",
    timeStamp: "04:44:44, 25-09-2023",
  },
  {
    locoId: 4789,
    stationId: 8392,
    previousReadTag: 831,
    categoryOfTag: "Duplicate Tag",
    missedTag: 732,
    timesMissed: 1,
    locosThatMissed: 432,
    absoluteLocation: 374102,
    eventCategory: "Early Tag Read",
    timeStamp: "04:44:44, 25-09-2023",
  },
  {
    locoId: 3205,
    stationId: 1578,
    previousReadTag: 178,
    categoryOfTag: "Main Tag",
    missedTag: 189,
    timesMissed: 2,
    locosThatMissed: 362,
    absoluteLocation: 159384,
    eventCategory: "Late Tag Read",
    timeStamp: "04:44:44, 25-09-2023",
  }
]

export const LIKELY_READER_FAULTS_DATA: LikelyReaderFault[] = [
  {
    locoId: 30451,
    stationsVisited: 6,
    tagsRead: 23,
    tagsMissed: 12,
  },
  {
    locoId: 30218,
    stationsVisited: 9,
    tagsRead: 12,
    tagsMissed: 19,
  },
  {
    locoId: 30902,
    stationsVisited: 3,
    tagsRead: 31,
    tagsMissed: 23,
  },
];

export const LIKELY_FAULTY_TAGS_DATA: LikelyFaultyTag[] = [
  {
    tagId: 196,
    tagType: "Physical",
    locosPassed: 23,
    locosMissed: 12,
  },
  {
    tagId: 375,
    tagType: "Physical",
    locosPassed: 12,
    locosMissed: 19,
  },
  {
    tagId: 459,
    tagType: "Physical",
    locosPassed: 31,
    locosMissed: 23,
  },
];

export const LOCO_STATION_MISS_HEATMAP_DATA: LocoStationMissHeatmap[] = [
  {
    locoId: 30451,
    station37002: 6,
    station37003: 2,
    station37004: 2,
    station37005: 2,
    totalMissed: 12,
  },
  {
    locoId: 30218,
    station37002: 9,
    station37003: 2,
    station37004: 3,
    station37005: 5,
    totalMissed: 19,
  },
  {
    locoId: 30902,
    station37002: 3,
    station37003: 5,
    station37004: 5,
    station37005: 10,
    totalMissed: 23,
  },
];

export const TAG_MISSING_NEW_TABLE = {
  LIKELY_READER_FAULTS: {
    header: "Likely Reader Faults",
    subtitle: "Across Multiple Stations",
    icon: IconTrain,
    api: "/likely-reader-faults",
    columns: TABLE_COLUMNS_CONFIG.LIKELY_READER_FAULTS,
    viewAllText: "View all reader faults",
  },
  LIKELY_FAULTY_TAGS: {
    header: "Likely Faulty Tags",
    subtitle: "Missed by Multiple Locos",
    icon: IconTag,
    api: "/likely-faulty-tags",
    columns: TABLE_COLUMNS_CONFIG.LIKELY_FAULTY_TAGS,
    viewAllText: "View all faulty tags",
  },
  LOCO_X_STATION_MISS_HEATMAP: {
    header: "Loco x Station Miss Heatmap",
    subtitle: "Loco missed a tag at that station",
    icon: IconTrain,
    api: "/loco-station-miss-heatmap",
    columns: TABLE_COLUMNS_CONFIG.LOCO_STATION_MISS_HEATMAP,
    viewAllText: "View complete heatmap",
  },
  TAG_MISS_CATEGORY: {
    header: "Tag Miss by Category",
    subtitle: "How many locos read or missed each tag",
    icon: IconTag,
    api: "/tag-read-vs-miss-comparison",
    barChart: [
      { key: 'earlyTagRead', label: 'Early Tag Read', backgroundColor: '#7C6EE6' },
      { key: 'lateTagRead', label: 'Late Tag Read', backgroundColor: '#ff2db2' },
      { key: 'physicalTagMiss', label: 'Physical Tag Miss', backgroundColor: '#F4A742' }
    ]
  },
}